import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Login from './Login';
import Home from './Home';
import Events from './Events';
import Admin from './components/UserRegistration';
import CircularProgress from './components/CircularProgress';
import { ensureSession, isAccessTokenValid } from './auth';

function ProtectedRoute({ children }: { children: React.ReactElement }) {
  const [allowed, setAllowed] = useState<boolean | null>(() =>
    isAccessTokenValid() ? true : null
  );

  useEffect(() => {
    if (isAccessTokenValid()) {
      setAllowed(true);
      return;
    }

    let cancelled = false;
    (async () => {
      const ok = await ensureSession();
      if (!cancelled) {
        setAllowed(ok);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (allowed === null) {
    return <CircularProgress />;
  }
  if (!allowed) {
    return <Navigate to="/login?reason=session_expired" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <Events />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              {localStorage.getItem('role') === 'admin' ? (
                <Admin />
              ) : (
                <Navigate to="/home" replace />
              )}
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
